













































import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import LoadingIndicator from '@components/LoadingIndicator'
import Validator from '@utils/validator'

settings =
  resources:
    password_reset_request: 
      resourceName: "password_reset_request"
      slug: "password_reset_request/:token/edit"
  vue: 
    components: { LoadingIndicator }
    data: ->
      formErrors: {}
      error: null
      isSubmitting: false

    computed:
      hasFormErrors: -> !!Object.values(@formErrors).length

    methods:
      clearFormErrorKey: (key) ->
        @formErrors ||= {}
        @formErrors[key] = null

      validateForm: ->
        errors = {}
        errors.password = 'Password is not valid' unless Validator.isPasswordValid @prime.password_reset_request.password
        errors.password_confirmation = 'Passwords don\'t match' unless @prime.password_reset_request.password is @prime.password_reset_request.password_confirmation
        @formErrors = errors

      resetClicked: () -> 
        @validateForm()
        return if @hasFormErrors

        return if !@prime.password_reset_request.password or !@prime.password_reset_request.password_confirmation
        @isSubmitting = true
        try 
          response = await RecessAPI.resetPassword @$route.query.token, { password_reset_request: @prime.password_reset_request }
          @isSubmitting = false
          
          (@error ||= err) for key,err of response.errors if response.errors?

          if !response.errors?
            @showFlash({ info: 'Password reseted' })
            @$router.push({ name: 'Login' })
        catch err
          # api error
          @error = err
          @isSubmitting = false
    created: ->
      if !@$route.query.stay?
        @clearStash()
        window.location.href += "&stay=yes"

      # @error = 'Invalid password reset link. Please try again.' unless @$route.query.token
      # @$router.replace '/reset' 
      
export default VueOptions.vue settings
